import { call, take, put, fork, cancel, cancelled } from 'redux-saga/effects'
import { eventChannel } from 'redux-saga'
import firebase from '../config/firebase'

import UserActions, { UserTypes } from '../reducers/userReducer'

const observer = ref => {
  const listener = eventChannel(emit => {
    const subscriber = ref.onSnapshot(
      querySnapshot => {
        const users = {}

        querySnapshot.forEach(doc => {
          users[doc.id] = doc.data()
        })

        emit(users)
      },
      err => {
        emit(new Error(err))
      }
    )

    return () => subscriber
  })
  return listener
}

export function* userObserver() {
  const ref = firebase
    .firestore()
    .collection('dashboard_users')
    .orderBy('role')

  const channel = yield call(observer, ref)
  try {
    while (true) {
      const users = yield take(channel)

      if (Object.keys(users).length > 0) {
        yield put(UserActions.getAllUsersSuccess(users))
      } else {
        yield put(UserActions.getAllUsersSuccess({}))
      }
    }
  } catch (err) {
    yield put(UserActions.getAllUsersFailure(err))
  } finally {
    if (yield cancelled()) {
      channel.close()
    }
  }
}

export function* getAllUsers() {
  const usersListener = yield fork(userObserver)

  yield take(UserTypes.REMOVE_USERS_LISTENER)
  yield cancel(usersListener)
}



// WEBPACK FOOTER //
// ./src/sagas/userSaga.js